import numberToPercentage from './numberToPercentage';
import numberToTime from './numberToTime';
import datetime from './datetime';
import duration from './duration';
import date from './date';
import time from './time';

export const filters = {
  numberToPercentage,
  numberToTime,
  datetime,
  duration,
  date,
  time,
};

export default function install(Vue) {
  Object.keys(filters).forEach((name) => {
    Vue.filter(name, filters[name]);
  });
}
